module.exports = __webpack_public_path__ + "static/media/frontlogo-text.bacbe505.svg";